import React, { useState } from 'react';
import { Breadcrumbs as BreadcrumbsMantine, Anchor } from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import HelmetTitle from '../../helmet_title/HelmetTitle';
import { ThemeSystem } from '../../../views/my-learning/dashboard/themeColor';

interface BreadcrumbsItemProps {
  title: string;
  href: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

interface BreadcrumbsProps {
  pageTitle?: string;
  withTitleContent?: boolean;
  itemList: BreadcrumbsItemProps[];
  theme?: ThemeSystem;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  pageTitle,
  itemList,
  withTitleContent = true,
  theme
}) => {
  const location = useLocation();
  const items = itemList.map((item, index) => {
    const isActive = location.pathname === item.href;
    if (item.icon)
      return (
        <Link
          className={`breadcrumbs__item ${theme?.type || ''}`}
          to={item.href}
          key={index}
          onClick={item.onClick}
          style={
            theme
              ? {
                  color: theme.colors.text
                }
              : {}
          }
        >
          {item.icon}
          {item.title}
        </Link>
      );

    if (index === itemList.length - 1)
      return (
        <span
          className={`breadcrumbs__item--active ${theme?.type || ''}`}
          style={
            theme
              ? {
                  color: theme.colors.text
                }
              : {}
          }
          key={index}
        >
          {item.title}
        </span>
      );

    return (
      <Link
        className={`breadcrumbs__item ${theme?.type || ''}`}
        to={item.href}
        key={index}
        onClick={item.onClick}
        style={
          theme
            ? {
                color: theme.colors.text
              }
            : {}
        }
      >
        {item.title}
      </Link>
    );
  });

  return (
    <div className="page">
      <HelmetTitle title={pageTitle ? `${pageTitle} ` : 'Beelajar 2.0'} />
      {withTitleContent && (
        <div className={`page--title ${theme?.type || ''}`}>
          <h2
            style={
              theme
                ? {
                    color: theme.colors.text
                  }
                : {}
            }
          >
            {pageTitle}
          </h2>
        </div>
      )}
      {items.length !== 0 && (
        <BreadcrumbsMantine separator={<FiChevronRight />}>
          {items}
        </BreadcrumbsMantine>
      )}
    </div>
  );
};

export default Breadcrumbs;
